import React from 'react';

interface BrandItem {
  image: string;
  name?: string;
  alt?: string;
  height?: string;
  width?: string;
  url?: string;
}

interface KidsaBrandsProps {
  title: string | string[];
  subtitle?: string;
  brands: BrandItem[];
}

const KidsaBrands: React.FC<KidsaBrandsProps> = ({
  title,
  subtitle,
  brands
}) => {
  const displayTitle = Array.isArray(title) ? title[0] : title;

  return (
    <div className="brand-section fix section-padding">
      <div className="container">
        <div className="brand-wrapper">
          {displayTitle && (
            <h6 className="text-center wow fadeInUp" data-wow-delay=".3s">
              {displayTitle}
            </h6>
          )}
          {subtitle && (
            <p className="text-center wow fadeInUp" data-wow-delay=".4s">
              {subtitle}
            </p>
          )}
          <div className="swiper brand-slider">
            <div className="swiper-wrapper">
              {brands.map((brand, index) => (
                <div key={index} className="swiper-slide">
                  <div className="brand-image">
                    {brand.url ? (
                      <a href={brand.url} target="_blank" rel="noopener noreferrer">
                        <img 
                          src={brand.image} 
                          alt={brand.alt || brand.name || "brand-img"} 
                          width={brand.width}
                        />
                      </a>
                    ) : (
                      <img 
                        src={brand.image} 
                        alt={brand.alt || brand.name || "brand-img"} 
                        width={brand.width}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KidsaBrands;